<template>
  <div class="messagebox">
    <transition name="fade">
      <div v-show="show" class="popup">
        <div class="content-box">
          <div class="poptitle">
            <h1>作品类型</h1>
          </div>
          <div @scroll="move" class="popcontent">
            <span class="tips">为了更好地评审作品，请补充作品类型信息</span>
            <div class="typelist">
              <ul>
                <li
                  class="typeitem"
                  v-for="(item, index) in worksTypes"
                  :key="index"
                  @click="choseItems(item, index)"
                  :class="activeindex === index ? 'active' : ''"
                  :style="{
                    display: item.display == 'YES' ? 'block' : 'none'
                  }"
                >
                  <p>{{ item.typeName }}</p>
                  <img v-if="activeindex == index" class="chosered" src="@/assets/images/icon_tick_red.png" />
                </li>
              </ul>
            </div>
          </div>
          <div v-show="isScroll" class="opacity"></div>
          <div class="unable" v-if="submittype == ''"></div>
          <div class="closeIcon" @click="modifyingdata">
            提交
          </div>
        </div>
        <div class="mask"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "messagebox",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rejectseason: {
      type: String,
      default: ""
    },
    worksTypes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      isScroll: false,
      activeindex: undefined,
      submittype: ""
    }
  },
  methods: {
    modifyingdata() {
      document.querySelector("#app").style.overflow = "auto"
      this.$emit("input", this.submittype)
      setTimeout(() => {
        let ele = document.querySelector(".popcontent")
        ele.scrollTop = 0
      }, 500)
    },
    move(e) {
      if (e.target.scrollTop !== 0) {
        this.isScroll = true
      } else {
        this.isScroll = false
      }
    },
    choseItems(item, index) {
      this.activeindex = index
      this.submittype = item.typeId
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.messagebox {
  z-index: 99999;
  .popup {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .content-box {
      position: relative;
      z-index: 99999;
      width: 6.4rem;
      background: #ffffff;
      border-radius: 0.2rem;
      background: url("../../assets/images/pop_head.png") #ffffff no-repeat top left;
      background-size: 100% auto;
      .poptitle {
        h1 {
          font-family: PingFangSC-Medium;
          width: 100%;
          text-align: center;
          font-size: 0.36rem;
          color: #333333;
          letter-spacing: 0;
          font-weight: normal;
          height: 1.3rem;
          line-height: 1.3rem;
        }
      }
      .popcontent {
        font-family: PingFangSC-Regular;
        font-size: 0.3rem;
        color: #333333;
        letter-spacing: 0;
        max-height: 7rem;
        overflow: auto;
        margin: 0;
        padding: 0 0.5rem;
        box-sizing: border-box;
        margin-top: 0.15rem;
        position: relative;
        padding-bottom: 0.2rem;
        .tips {
          display: block;
          width: 100%;
          font-family: PingFang-SC-Medium;
          font-size: 0.26rem;
          color: #f64e45;
          letter-spacing: 0;
          text-align: center;
          margin-bottom: 0.4rem;
        }
        .typelist {
          width: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          ul {
            width: 3.6rem;
            .typeitem {
              border: 0.5px solid #999999;
              border-radius: 0.08rem;
              position: relative;
              width: 100%;
              margin-bottom: 0.3rem;
              p {
                width: 100%;
                font-family: PingFang-SC-Medium;
                font-size: 0.3rem;
                color: #333333;
                letter-spacing: 0;
                text-align: center;
                line-height: 0.74rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
              .chosered {
                position: absolute;
                top: 0.2rem;
                right: 0.2rem;
                display: block;
                width: 0.34rem;
                height: 0.34rem;
              }
            }
            .active {
              background: #fff4f4 !important;
              border: 1px solid #f64e45 !important;
              p {
                color: #f64e45;
              }
            }
          }
        }
      }
      .opacity {
        width: 100%;
        height: 2rem;
        position: absolute;
        top: 1.3rem;
        left: 0;
        z-index: 6;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 30%);
        pointer-events: none;
      }
      .closeIcon {
        font-family: PingFang-SC-Medium;
        font-size: 0.34rem;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        width: 100%;
        height: 0.94rem;
        line-height: 0.94rem;
        background: #f64e45;
        border-radius: 0px 0px 0.2rem 0.2rem;
      }
      .unable {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.94rem;
        line-height: 0.94rem;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 0px 0px 0.2rem 0.2rem;
      }
    }
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 6;
    }
  }
}
</style>
